export default "__VITE_ASSET__BAxfs90K__"